import React from 'react';

import { IRouter } from '@routers/interface';

export const routerCheckCode: IRouter = {
  path: '/check-code',
  loader: React.lazy(() => import('./index')),
  exact: true,
};
